/** Preview / admin mode: show correct answers only, without user-answer comparison. */
export function isHighlightOnlyAnswer(answer) {
    return Boolean(answer?.highlightOnly);
}

export function getNumericalScaleOptionScores(actions) {
    const optionScores = {};
    Object.keys(actions?.values || {}).forEach((optionValue) => {
        const entries = actions.values[optionValue];
        optionScores[optionValue] = Array.isArray(entries)
            ? entries.reduce((sum, entry) => sum + (entry.score || 0), 0)
            : 0;
    });
    return optionScores;
}

export function getMaxPositiveScore(optionScores = {}) {
    return Math.max(0, ...Object.values(optionScores));
}
